import type { HTMLChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import { type IconName } from 'public/icons/name';
import React from 'react';

import config from 'configs/app';
import { Skeleton } from 'toolkit/chakra/skeleton';

export const href = config.app.spriteHash ? `/icons/sprite.${config.app.spriteHash}.svg` : '/icons/sprite.svg';

export { IconName };

interface Props extends HTMLChakraProps<'div'> {
  name: IconName;
  isLoading?: boolean;
}

const IconSvg = React.forwardRef(function IconSvg(
  { name, isLoading = false, ...props }: Props,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const style: React.CSSProperties =
    name === 'testnet'
      ? {
        width: '100%',
        height: '30px',
        padding: '0px',
        position: 'relative',
        top: '-5px',
      }
      : {};

  return (
    <Skeleton loading={isLoading} display="inline-block" asChild {...props} ref={ref}>
      <chakra.svg style={style} w="100%" h="100%">
        <use href={`${href}#${name}`} />
      </chakra.svg>
    </Skeleton>
  );
}
);



IconSvg.displayName = 'IconSvg';

export default IconSvg;
